// IMPORT PACKAGE REFERENCES
import React, { Fragment } from 'react';

import PropTypes from 'prop-types';

// COMPONENT
const renderList = analysisCompleteUserStats => (
    <table className="table table-hover">
        <thead>
            <tr>
                <th scope="col">Reviewer</th>
                <th scope="col">Completed Reviews</th>
            </tr>
        </thead>
        <tbody>
            {analysisCompleteUserStats.map(analyst =>
                renderListItem(analyst.analystUid, analyst.count)
            )}
        </tbody>
        <tfoot>
            <tr>
                <td />
                <td className="text-right">
                    Total:{' '}
                    {analysisCompleteUserStats.reduce(
                        (accumulator, item) => accumulator + parseInt(item.count),
                        0
                    )}
                </td>
            </tr>
        </tfoot>
    </table>
);

const renderListItem = (analystUid, count) => (
    <tr key={analystUid}>
        <td>{analystUid}</td>
        <td>{count}</td>
    </tr>
);

const AnalysisCompleteUserStatsTable = props => (
    <Fragment>{renderList(props.analysisCompleteUserStats)}</Fragment>
);

AnalysisCompleteUserStatsTable.propTypes = {
    analysisCompleteUserStats: PropTypes.array.isRequired,
};

export { AnalysisCompleteUserStatsTable };
